import configData from "./config.json";

const { URL_BAO_CAO,URL_BAO_CAO_LOCAL } = configData;
const URL = window.location.hostname === 'localhost' ? URL_BAO_CAO_LOCAL : URL_BAO_CAO;
export const URL_API_BAO_CAO = URL ;